<template>
  <div>
    <div class="web2">
      <div class="outterBox">
        <div class="topHeader">
          <span> 티오프 선택 </span>
          <span class="headerDetailText"> 복수 일자 일괄 접수 가능 (※ 내장자 別 일괄 접수 요망) </span>
        </div>

        <b-modal id="errDialog" :title="title" centered ok-title="확인" ok-only>
          <div class="bg-white p-3 rounded box-shadow">
            <p class="text-muted mb-0">
              {{ errDialogMsg1 }}
            </p>
            <p v-if="errDialogMsg2">{{ errDialogMsg2 }}</p>
          </div>
        </b-modal>
        <div class="top">
          <div class="dateColumn">
            <!-- 로딩 상태일 때 로딩 애니메이션 표시 -->
            <div v-if="isLoading" class="loading-container">
              <div class="loading-spinner"></div>
              <div class="loading-text">티오프 정보를 불러오는 중...</div>
            </div>
            <!-- 로딩이 완료되면 티오프 목록 표시 -->
            <div v-else v-for="i in teeOffList" :key="i.detail">
              <article class="feature1">
                <input
                  type="checkbox"
                  :value="i"
                  v-model="selectedTeeOffList"
                  @change="check($event, i)"
                  :disabled="disable(i)"
                />
                <div>
                  <span>
                    {{ i.detailName }}
                  </span>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile2">
      <div class="outterBox">
        <div class="topHeader">
          <span> 티오프 선택 </span>
        </div>
        <b-modal id="errDialog" :title="title" centered ok-title="확인" ok-only>
          <div class="bg-white p-3 rounded box-shadow">
            <p class="text-muted mb-0">
              {{ errDialogMsg1 }}
            </p>
            <p v-if="errDialogMsg2">{{ errDialogMsg2 }}</p>
          </div>
        </b-modal>
        <div class="top">
          <div class="rowSpace"></div>
          <div class="dateColumn">
            <div class="checkGroup">
              <!-- 로딩 상태일 때 로딩 애니메이션 표시 -->
              <div v-if="isLoading" class="loading-container">
                <div class="loading-spinner"></div>
                <div class="loading-text">티오프 정보를 불러오는 중...</div>
              </div>
              <!-- 로딩이 완료되면 티오프 목록 표시 -->
              <div v-else v-for="i in teeOffList" :key="i.detail">
                <article class="feature1">
                  <input
                    type="checkbox"
                    :value="i"
                    v-model="selectedTeeOffList"
                    @change="check($event, i)"
                    :disabled="disable(i)"
                  />
                  <div>
                    <span>
                      {{ i.detailName }}
                    </span>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import reserveService from '@/services/rev.service';
import {hhmmStr, PMSReqGolfReceiptNew, PMSReqGolfReceiptNewDetail} from '@/models-golf';
import moment from 'moment';
import {ReceiptViewModel} from '@/pages/RevReceiptPage/Model/receiptModel';
import {DateUtil} from '@/util/DateUtil';

export default {
  name: 'TeeOffPicker',
  components: {},
  props: {
    listType: String,
    revConfirmList: Array,
  },
  filters: {
    hhmmStr(value) {
      return hhmmStr(value);
    },
  },
  watch: {
    selectedDate(newVal, oldVal) {
      this.refreshReserveCount();
    },
  },
  computed: {
    totalCourseString(newVal, oldVal) {
      let courseName = '';
      this.totalCourse.map(x => {
        if (courseName === '') {
          courseName += x.coseName;
        } else {
          courseName += `,${x.coseName}`;
        }
      });
      return courseName;
    },
  },

  data() {
    return {
      title: '',
      errDialogMsg1: '',
      errDialogMsg2: '',

      // 전달 데이터
      selectedDate: null,
      selectedCourse: null,
      totalCourse: [],

      teeOffList: [],
      selectedTeeOffList: [],

      limitCount: 0,
      reservCount: 0,
      isLoading: false, // 로딩 상태 추가
    };
  },
  async created() {
    this.$EventBus.$on('RevCourseChanged', this.revCourseChanged);
    this.$EventBus.$on('UpdateDot', this.checkExistSelection);
    this.$EventBus.$on('TeeOffLoadingStart', this.startLoading);
    this.$EventBus.$on('TeeOffLoadingEnd', this.endLoading);
    await this.refreshReserveCount();
  },
  beforeDestroy() {
    this.$EventBus.$off('RevCourseChanged', this.revCourseChanged);
    this.$EventBus.$off('UpdateDot', this.checkExistSelection);
    this.$EventBus.$off('TeeOffLoadingStart', this.startLoading);
    this.$EventBus.$off('TeeOffLoadingEnd', this.endLoading);
  },

  methods: {
    async refreshReserveCount() {
      let user = this.$store.getters['Auth/selectedMember'];
      const reqResult = await reserveService.getRevCountCheck(this.listType, this.selectedDate, user.memNo);
      this.limitCount = reqResult.obj.limitCount;
      this.reservCount = reqResult.obj.reservCount;
    },

    disable(teeOffData) {
      let targetIndex = this.selectedTeeOffList.findIndex(x => {
        let flag1 = x.detail === teeOffData.detail;
        let flag2 = x.detailName === teeOffData.detailName;
        return flag1 && flag2;
      });

      if (targetIndex > -1) {
        return false;
      } else {
        return this.getAvailableCount() + this.reservCount >= this.limitCount;
      }
    },

    getAvailableCount() {
      let teamCount = 0;
      this.revConfirmList.forEach(x => {
        if (x.CompareWithDateAndCourse(this.selectedDate, this.selectedCourse)) {
          teamCount += x.teamCount;
        }
      });
      return teamCount;
    },

    makeReceiptConfirmModel(teeOffData) {
      // 사전 예약 모델 생성
      let data = new ReceiptViewModel();
      data.selectedDate = this.selectedDate;
      data.selectedCourse = this.selectedCourse;
      data.selectedTeeOff = teeOffData;
      data.teamCount = 1;
      data.teamLimitCount = this.limitCount;
      data.teamReservCount = this.reservCount;

      // 사용자 정보 추가
      // 사전 접수의 경우 > 회원권 번호-> 예약자 번호, 예약자명 -> 회원권 이름
      let loginUser = this.$store.getters['Auth/loginUser'];
      let selectedMember = this.$store.getters['Auth/selectedMember'];

      data.receiptDetail.bookName = loginUser.guestName;
      data.receiptDetail.memNo = selectedMember.memNo;
      data.receiptDetail.hpNo = loginUser.hpNo;

      console.log(loginUser, selectedMember, data.receiptDetail);

      return data;
    },

    check(event, teeOffData) {
      let canContinue = true;
      if (event.target.checked) {
        // checked
        if (this.selectedTeeOffList.length + this.reservCount > this.limitCount) {
          canContinue = false;
        }
      }

      if (canContinue) {
        // 잔여수량 있을 경우 체크 항목 목록에 추가
        let func = event.target.checked ? 'AddReceipt' : 'RemoveReceipt';
        this.$EventBus.$emit(func, this.makeReceiptConfirmModel(teeOffData));
      } else {
        // 초과 될 경우 체크 해제
        let targetIndex = this.selectedTeeOffList.findIndex(x => {
          let flag1 = x.detail === teeOffData.detail;
          let flag2 = x.detailName === teeOffData.detailName;
          return flag1 && flag2;
        });

        if (targetIndex > -1) {
          this.selectedTeeOffList.splice(targetIndex, 1);
          event.target.checked = false;
        }
      }
    },

    checkExistSelection() {
      this.selectedTeeOffList = [];
      this.revConfirmList.forEach(x => {
        if (x.CompareWithDateAndCourse(this.selectedDate, this.selectedCourse)) {
          let removeTarget = [];
          console.log(x, this.teeOffList);
          this.teeOffList.forEach(t => {
            let flag6 = x.selectedTeeOff.detail === t.detail;
            let flag7 = x.selectedTeeOff.detailName === t.detailName;
            if (flag6 && flag7) {
              this.selectedTeeOffList.push(x.selectedTeeOff);
            }
          });
        }
      });

      console.log('this.selectedTeeOffList', this.selectedTeeOffList);
    },

    async revCourseChanged(data) {
      try {
        // SET PARAM to DATA
        this.selectedDate = data.selectedDate;
        this.selectedCourse = data.selectedCourse;
        this.totalCourse = data.totalCourse;

        if (this.selectedCourse && this.selectedCourse.coseCd) {
          // 코스 선택값이 있을 경우
          // 사전 접수, 대기 접수 의 경우 첫 번째 Element 를 보내줌
          const reqResult = await reserveService.getGolfDateTeeTimeList(
            this.listType,
            this.selectedDate,
            this.selectedCourse.coseCd,
          );
          this.teeOffList = reqResult.items;
          this.checkExistSelection();
        } else {
          this.showDialog(`해당 날짜에 조회된 코스 정보가 없습니다.`);
        }
      } catch (error) {
        console.error('티오프 정보 로드 중 에러:', error);
        this.showDialog('티오프 정보를 불러오는 중 오류가 발생했습니다.');
      } finally {
        // 로딩 완료
        this.isLoading = false;
      }
    },

    showDialog(title, errDialogMsg1, errDialogMsg2) {
      this.title = title;
      this.errDialogMsg1 = errDialogMsg1;
      this.errDialogMsg2 = errDialogMsg2;
      this.$bvModal.show('errDialog');
    },

    startLoading() {
      this.isLoading = true;
      this.selectedTeeOffList = [];
      this.teeOffList = [];
    },

    endLoading() {
      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.topHeader {
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-left: 1rem;
  font-weight: bold;
  font-size: 1.3rem;
  .headerDetailText {
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.3;
    color: #999999;
    margin-top: 0.3rem;
  }
}

.top {
  display: flex;
  padding: 1rem;
}

article {
  position: relative;
  width: 100%;
  height: 2.3rem;
  box-sizing: border-box;
}

article div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 25px;
  transition: 0.1s ease;
  border: 1px solid #bdbdbd;
}

article input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

input[type='checkbox']:checked ~ div {
  background-color: #af8c5e;
  color: #dddddd;
}

input[type='checkbox']:disabled ~ div {
  background-color: #eeeeee;
  color: #afafaf;
  border: 1px solid #d1d1d1;
}
.mobile2 {
  display: none;
}
.web2 {
  .outterBox {
    border: 0px solid #6e6e6e;
    height: 70%;
  }

  margin: 0;
  padding: 0;
  .col {
    font-size: 0.9rem;
  }
  .row {
    font-size: 0.9rem;
  }
  .top {
    display: flex;
    padding: 1rem;
    .dateColumn {
      width: 100%;
      background-color: white;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(6rem, 1fr));
      gap: 0.4rem;
    }
  }
}

@media (max-width: 992px) {
  hr {
    margin: 0px;
  }
  .web2 {
    display: none;
    margin: 0;
    padding: 0;
  }
  .mobile2 {
    display: block;
    .col {
      font-size: 0.9rem;
    }
    .row {
      font-size: 0.9rem;
    }
    .topHeader {
      padding-top: 2rem;
      padding-left: 1rem;
      font-weight: bold;
      font-size: 1.3rem;
      .subinfo {
        font-size: 0.7rem;
        color: #727272;
        margin-left: 1rem;
      }
    }
    .outterBox {
      width: 100%;
      .top {
        display: flex;
        padding: 1rem;

        .dateColumn {
          padding: 0.5rem;
          width: 100%;
          background-color: white;
          display: inline-block;

          .checkGroup {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(6rem, 1fr));
            gap: 0.4rem;
            margin-left: auto;
            margin-right: auto;
            width: 100%;
          }
        }
      }
    }
  }
}
.rowSpace {
  height: 1rem;
}
.colSpace {
  width: 1rem;
}

/* 로딩 애니메이션 스타일 */
.loading-container {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  height: 200px; /* 고정 높이로 UI 떨림 방지 */
  min-height: 200px;
}

.loading-spinner {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #af8c5e;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.loading-text {
  color: #666;
  font-size: 0.9rem;
  text-align: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
